import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { CustomsnapshotService } from '../Services/customsnapshot.service';
import { SnapshotService } from '../Services/snapshot.service';
import * as _ from 'lodash';

@Component({
  selector: 'app-output-popup',
  templateUrl: './output-popup.component.html',
  styleUrls: ['./output-popup.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OutputPopupComponent {
  @Output() dataEvent = new EventEmitter<boolean>();
  @Output() dataEventTrend = new EventEmitter<boolean>();
  @Output() dataEventCustom = new EventEmitter<boolean>();
  @Input() popUpParameter = '';
  @Input() visualization = '';
  @Input() id: number | undefined;
  @Input() item: any;
  @Input() data: any;
  @Input() customData: any;
  @Input() snapProduct: string = '';
  @Input() multiFunnelPopup: boolean = false;
  @Input() brandList: any = []
  @Input() metricList: any = [];
  @Input() trendLineView: any;
  @Input() showSnapshotARK: any;
  isviewDropdownOpen: any = false;
  clickedResult = '';
  Top10Container: boolean = false;
  Top10Toggle: boolean = true;
  DataLabelOn: boolean = false;
  BMList: any = [];
  viewList: any = [];
  charttype: string = "";
  zAxisMetric: string = "";
  viewListBrands: any[] = [
    {
      option: "All Brands for Selected Metric",
      selected: true,
    }, {
      option: "All Metrics for Selected Brand",
      selected: false,
    },
  ]
  viewListMarkets: any = [
    {
      option: "All Markets for Selected Metric",
      selected: true,
    }, {
      option: "All Metrics for Selected Market",
      selected: false,
    },
  ]

  constructor(private _cdref: ChangeDetectorRef, private _configCustomService: CustomsnapshotService, public _configService: SnapshotService) {
    this.viewList = this.viewListBrands;

  }

  gridData: any = [];
  toogleBrandMetricDropdownOpen: any = false;
  toogleViewDropdown() {
    this.isviewDropdownOpen = !this.isviewDropdownOpen;
    event?.stopPropagation();
  }
  closeViewDropdown() {
    this.isviewDropdownOpen = false;
  }
  toogleBrandMetricDropdown() {
    this.toogleBrandMetricDropdownOpen = !this.toogleBrandMetricDropdownOpen
    event?.stopPropagation();
  }


  isTrendView: boolean = true;
  isSampleSize: boolean = false;
  toggleTrendSample(view: any) {
    if (view == 'trendview') {
      this.isTrendView = true;
      this.isSampleSize = false;
    }
    else {
      this.prepareSampleSize();

    }
  }

  closeBrandMetricDropdown() {
    this.toogleBrandMetricDropdownOpen = false;
  }
  ngOnInit() {

    if (this.snapProduct == "custom") {
      const FoundItem = this.customData.metric.find((item: any) => item.metric_option === "ZAxis Metric : ");
      if (FoundItem)
        this.zAxisMetric = FoundItem.metric_value[0].option;
      //  this.zAxisMetric = this.customData.metric.find((item:any) => item.metric_option === "ZAxis Metric : "
      //                                                           ).metric_value[0].option;
      this.charttype = this.customData.widgetchart_name;
      if (this._configService.selectedcompareacrossOption.replace(/\s+/g, '').toLowerCase() == "multiplebrands") {
        this.viewList = this.viewListBrands;
        this.viewselected = this.viewList[0].option;
      }
      if (this._configService.selectedcompareacrossOption.replace(/\s+/g, '').toLowerCase() == "multiplemarkets") {
        this.viewList = this.viewListMarkets;
        this.viewselected = this.viewList[0].option;
      }
      if (this.multiFunnelPopup) {
        const isAudienceSnapshot = this._configService.selectedSnapshotType.toLowerCase().includes('audience') && this._configService.multiCohort;
        this.customData.metric[0].metric_value[0].data.forEach((d: any) => {
          // For audience snapshot, extract the audience name from colChild (e.g., "Audience|Gender|Male" -> "Male")
          let headerValue = d.colChild;
          if (isAudienceSnapshot && d.colChild && d.colChild.includes('|')) {
            headerValue = d.colChild.split('|').pop();
          }
          this.gridData.push({
            header: headerValue,
            data: this.customData
          })
        })
      }
      if (this.metricList.length > 0) {
        this.metricSelected = this.metricList[0];
        this.metricList = this.metricList.map((m: any, index: any) => {
          return {
            option: m,
            selected: index === 0
          }
        })

      }
      if (this.brandList.length > 0) {
        this.brandSelected = "";
        this.brandList = this.brandList.map((m: any, index: any) => {
          return {
            option: m,
            selected: index === 0
          }
        })

      }
      this.BMList = this.metricList;
    }
    else {
      if (
        this.data[0].metricSelected.metrics.length > 10 &&
        this.visualization === 'Line Chart'
      ) {
        this.Top10Container = true;
      }
      if (this.visualization == 'Funnel Chart') {
        this.data[0].metricSelected.metrics.sort((a: any, b: any) => a.selectorder - b.selectorder);
      }
      if (this.Top10Container == true) {
        this.Top10Toggle = true;
      }
    }

  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.visualization == 'Funnel Chart') {
      this.data[0].metricSelected.metrics.sort((a: any, b: any) => a.selectorder - b.selectorder);
    }
  }
  viewselected: any = "All Brands for Selected Metric";
  viewSelected(item: any) {
    this.viewList.forEach((v: any) => {
      if (item.option == v.option) {
        v.selected = true;
        this.viewselected = v.option;
        if (this._configService.selectedcompareacrossOption.replace(/\s+/g, '').toLowerCase() == "multiplebrands") {
          if (v.option == "All Brands for Selected Metric") {
            this.brandSelected = "";
            this.metricList.forEach((m: any, index: any) => {
              m.selected = index === 0;
            })
            this.BMList = this.metricList;
          }
          else {
            this.metricSelected = "";
            this.brandList.forEach((m: any, index: any) => {
              m.selected = index === 0;
            })
            this.brandSelected = this.brandList[0].option;
            this.BMList = this.brandList;
          }
        }
        if (this._configService.selectedcompareacrossOption.replace(/\s+/g, '').toLowerCase() == "multiplemarkets") {
          if (v.option == "All Markets for Selected Metric") {
            this.brandSelected = "";
            this.metricList.forEach((m: any, index: any) => {
              m.selected = index === 0;
            })
            this.BMList = this.metricList;
          }
          else {
            this.metricSelected = "";
            this.brandList.forEach((m: any, index: any) => {
              m.selected = index === 0;
            })
            this.brandSelected = this.brandList[0].option;
            this.BMList = this.brandList;
          }
        }
      }
      else {
        v.selected = false;
      }
      this._cdref.detectChanges();
    })
  }
  metricSelected: any = "";
  brandSelected: any = "";
  brandMetricSelected(item: any, itemindex: any) {
    if (this._configService.selectedcompareacrossOption.replace(/\s+/g, '').toLowerCase() == "multiplebrands") {
      if (this.viewselected == "All Brands for Selected Metric") {
        this.metricList.forEach((v: any, index: any) => {
          if (item.option == v.option && index == itemindex) {
            v.selected = true;
            this.metricSelected = v.option;
          }
          else {
            v.selected = false;
          }
        })
      }
      else {
        this.brandList.forEach((v: any, index: any) => {
          if (item.option == v.option && index == itemindex) {
            v.selected = true;
            this.brandSelected = v.option;
          }
          else {
            v.selected = false;
          }
        })
      }
    }
    if (this._configService.selectedcompareacrossOption.replace(/\s+/g, '').toLowerCase() == "multiplemarkets") {
      if (this.viewselected == "All Markets for Selected Metric") {
        this.metricList.forEach((v: any, index: any) => {
          if (item.option == v.option && index == itemindex) {
            v.selected = true;
            this.metricSelected = v.option;
          }
          else {
            v.selected = false;
          }
        })
      }
      else {
        this.brandList.forEach((v: any, index: any) => {
          if (item.option == v.option && index == itemindex) {
            v.selected = true;
            this.brandSelected = v.option;
          }
          else {
            v.selected = false;
          }
        })
      }
    }
  }

  Top10selected() {
    this.Top10Toggle = true;
  }

  Allselected() {
    this.Top10Toggle = false;
  }

  DataLabelOnClick() {
    this.DataLabelOn = true;
  }

  DataLabelOffClick() {
    this.DataLabelOn = false;
  }

  collapseExandPopup() {
    this.dataEvent.emit(false);
    this.dataEventCustom.emit(false);

    this.dataEventTrend.emit(false);
  }


  opobject: any = {
    Column: [], Row: []
  }
  TrendToggleContainer: boolean = false;
  TrendToggleOn: boolean = false;
  weightSelectedValue: any = "";
  sampleSizeOutputData: any = [];
  OutputdataObject: any = {
    Column: [], Row: []
  }
  prepareSampleSize() {
    this.opobject = {
      Column: [], Row: []
    }


    this.TrendToggleContainer = true;
    this.TrendToggleOn = true;
    let data = [this.customData]

    const widgetDetailsInParticularPage = data.map((item: any) => item.widget_name);
    let uniqueObjects = [
      ...new Map(
        this._configService.trendOutputDbCallData
          .filter((i: any) => widgetDetailsInParticularPage.indexOf(i.widgetName) > -1)
          .map((item: any) => [item.widgetName, item])
      ).values()
    ];

    let pagedetails = _.cloneDeep(
      this._configService.trendOutputDbCallData.filter((i: any) => widgetDetailsInParticularPage.indexOf(i.widgetName) > -1)
    );

    uniqueObjects.forEach((i: any) => {
      let nestedArray1 = pagedetails
        .filter(
          (p: any) =>
            p.widgetName == i.widgetName
        )
        .map((p: any) => {
          return {
            CalculationType: p.CalculationType,
            Child: p.rowChild,
            Level1ColChild: p.Level1ColChild,
            NestedArray: [],
            customCalculationId: p.customCalculationId || null,
            customGroupId: p.customGroupId || null,
            isCustomCalculation: p.isCustomCalculation || false,
            isCustomGroup: p.isCustomGroup || false,
            isDerived: p.isDerived || false,
            responsecode:  p.rowResponseCode?.toString() ?? null,
            variablecode: p.rowVariableCode,
            unweightedBase:
              this._configService.getDropdownValues()?.['baseType']?.toLowerCase() == 'total base'
                ? p.totalUnweightedBase
                : p.answerUnweightedBase,
            weightedBase:
              this._configService.getDropdownValues()?.['baseType']?.toLowerCase() == 'total base'
                ? p.totalWeightedBase
                : p.answerWeightedBase,
            WeightedNumerator:
              this._configService.getDropdownValues()?.['baseType']?.toLowerCase() == 'total base'
                ? p.totalWeightedNumerator
                : p.answerWeightedNumerator,
            UnweightedNumerator:
              this._configService.getDropdownValues()?.['baseType']?.toLowerCase() == 'total base'
                ? p.CurrentNumeratorUnWeighted_Total
                : p.CurrentNumeratorUnWeighted_Answer,
            trend: true,
            brand: p.colChild.split("|")[1],
            ChildName: p.rowChild.includes("|") ? p.rowChild.split("|")[1].trim() : p.rowChild
          };
        });


      this.opobject.Row.push({
        Data: [{
          CalculationType: i.CalculationType || "share",
          Child: i.widgetName,
          Level1ColChild: i.Level1ColChild,
          NestedArray: nestedArray1,
          customCalculationId: i.customCalculationId || null,
          customGroupId: i.customGroupId || null,
          isCustomCalculation: i.isCustomCalculation || false,
          isCustomGroup: i.isCustomGroup || false,
          isDerived: i.isDerived || false,
          responsecode: "1",
          variablecode: "MO_MOb_2b_DAYPART",
          ChildName: i.Level1ColChild.includes("|") ? i.Level1ColChild.split("|")[1].trim() : i.Level1ColChild
        }
        ],
        Data1: [{ NestedArray: [] }],
        Parent: i.colChild,
        customCalculationId: i.customCalculationId || null,
        customGroupId: i.customGroupId || null,
        isCustomCalculation: i.isCustomCalculation || false,
        isCustomGroup: i.isCustomGroup || false
      })
    })

    let uniqueColObjects = Object.values(this._configService.trendOutputDbCallData.reduce((acc: any, obj: any) => {
      acc[obj.Level1ColChild] = obj;
      return acc;
    }, {}));

    uniqueColObjects.sort((a: any, b: any) => {
      const aCode = this.parseResponseCode(a.Level1ColResponseCode);
      const bCode = this.parseResponseCode(b.Level1ColResponseCode);

      // Compare year first, then number if years are equal
      if (!Number.isNaN(aCode.year) && !Number.isNaN(bCode.year)) {
        if (aCode.year !== bCode.year) {
          return aCode.year - bCode.year;
        }
      }
      return aCode.num - bCode.num;
    });

    uniqueColObjects.sort((a: any, b: any) => {
      let firstData = a.Level1ColChild;
      let secondData = b.Level1ColChild;
      if (firstData.includes("|")) {
        firstData = firstData.split("|")[1]
        secondData = secondData.split("|")[1];

        if (firstData.includes("_")) {
          firstData = firstData.split("_")[1];
          secondData = secondData.split("_")[1];
        }

        firstData = parseInt(firstData);
        secondData = parseInt(secondData);
      } else {
        firstData = parseInt(firstData);
        secondData = parseInt(secondData);

      }
      return firstData - secondData;
    })
    uniqueColObjects.forEach((i: any) => {
      let col = {
        Data: [{
          CalculationType: i.CalculationType,
          Child: i.Level1ColChild,
          NestedArray: [],
          customCalculationId: null,
          customGroupId: null,
          isCustomCalculation: false,
          isCustomGroup: false,
          isDerived: false,
          responsecode: i.Level1ColResponseCode,
          variablecode: i.Level1NestColVariableCode,
          ChildName: i.Level1ColChild.includes("|") ? i.Level1ColChild.split("|")[1].trim() : i.Level1ColChild
        }],
        Parent: "Month",
        customCalculationId: null,
        isCustomCalculation: false,
        isCustomGroup: false
      }
      if (!this.opobject.Column.includes(col)) {
        this.opobject.Column.push(col);
      }
    })


    //     Level1ColChild
    // : 
    // "Month|May_2023"
    // Level1ColResponseCode
    // : 
    // "5 2023"
    // Level1NestColVariableCode
    // : 
    // "Month_code"

    this.sampleSizeOutputData = JSON.parse(JSON.stringify(this._configService.trendOutputDbCallData));
    this.sampleSizeOutputData = this.sampleSizeOutputData.filter((m: any) => widgetDetailsInParticularPage.indexOf(m.widgetName) > -1)

    this.OutputdataObject = this.opobject;
    this.isSampleSize = true;



    this.isTrendView = false;
    this.isSampleSize = true;

  }

  parseResponseCode(code: any) {
    const [num, year] = code.split(' ');
    return { num: parseInt(num, 10), year: parseInt(year, 10) };
  };
}
